import { timelineEmbedEntrypoint } from '@jira/spa-apps__business-timeline-embed/src/timelineEmbedEntrypoint.entrypoint.tsx';
import { timelineEntrypoint } from '@jira/spa-apps__business-harmonised-timeline/src/timelineEntrypoint.entrypoint.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraBusinessTimelineEmbedRoute } from '@jira/router-routes__business-timeline-routes/src/jiraBusinessTimelineEmbedRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';

const timelineEmbedPageEntrypoint = createChromelessEntryPoint({
	main: timelineEntrypoint,
});

const legacyimelineEmbedPageEntrypoint = createChromelessEntryPoint({
	main: timelineEmbedEntrypoint,
});

export const jiraBusinessTimelineEmbedRouteEntry: Route = createEntry(
	jiraBusinessTimelineEmbedRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.timeline-embed-view',
		layout: chromelessLayout,
		skeleton: ThemedLazySkeleton,
		resources: getProjectViewResources(),
		supportsProjectTheme: 'full',
		entryPoint: () =>
			// eslint-disable-next-line jira/ff/no-preconditioning
			fg('jira_harmonised_business_timeline_embed') &&
			fg('jira_timeline_harmonisation_m1_targeting')
				? timelineEmbedPageEntrypoint
				: legacyimelineEmbedPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
